import React from 'react';
import BusinessDashboardPage from '@/pages/BusinessDashboardPage';

export default function ArtisanDashboardPage() {
  return <BusinessDashboardPage role="artisan" />;
}
